import { h } from './h.js';
import { getIcon } from './icons';
import { HOST, IForecast } from './forecast';
import { currentTheme } from './theme';

export function RadarView(forecast: IForecast) {
  const { latitude, longitude, relativeLocation } = forecast;

  const img = h('img', {
    className: 'radar--img',
    alt: `Radar loop near ${relativeLocation.city}`,
    fetchpriority: 'high',
    src: `${HOST}/radar?latitude=${latitude}&longitude=${longitude}&theme=${currentTheme()}`,
  });

  return h('div', { className: 'radar' },
    img,
    CurrentConditions(forecast),
  );
}

function CurrentConditions(forecast: IForecast) {
  const { temperature, shortForecast } = forecast.conditions;

  return h('div', { className: 'radar--overlay' },
    h('span', { className: 'temp radar--temp' }, `${Math.round(temperature)}`),
    h('span', { className: 'radar--condition' }, `${getIcon(shortForecast)} ${shortForecast.toLowerCase()}`),
  );
}
